import { createReducer, on } from '@ngrx/store';

import { fetchPicsForProjectSuccess } from './pics.actions';
import { PicsSliceState } from './pics.state';

export const picsReducer = createReducer<PicsSliceState>(
	new PicsSliceState(),
	on(fetchPicsForProjectSuccess, (state, action) => state.setPics(action.pics))
);
